import IntegrationList from './component'

export default IntegrationList
